// @flow
import createMessages from 'mz-intl/create'

const MESSAGES: { [key: $Keys<typeof MESSAGES>]: $Values<typeof MESSAGES> } = {
  UNABLE_CREATE_RESERVATION:
    "We are sorry, but the reservation can't be created due to a problem on the provider's side. Please try again.",
  UNKNOWN_ERROR:
    'Sorry, something went wrong. Please try again or contact our support.',
}

export default createMessages<typeof MESSAGES>('SDK_JS', MESSAGES)
